import React from 'react';
import { Link } from 'react-router-dom';
import DashboardCard from './components/DashboardCard';
import ChartSelect from './components/ChartSelect';
import ChartMain from './components/ChartMain';
import RecentWithdrawl from './components/RecentWithdrawl';
import RecentRefund from './components/RecentRefund';
import RecentTenantApproval from './components/RecentTenantApproval';

function Dashboard() {
  return (
    <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
      <div className="col-12">
        <h1 className="text-30 lh-14 fw-600">Dashboard</h1>
        <DashboardCard />

        <div className="row y-gap-30 pt-20 chart_responsive">
          <div className="col-12 col-lg-6">
            <div className="py-30 px-30 rounded-4 bg-white shadow-3 h-100">
              <div className="d-flex justify-between items-center">
                <h2 className="text-16 lh-1 fw-500">Penarikan Dana</h2>
                <div>
                  <Link to="/withdrawl" className="text-12 text-blue-1 fw-500 underline">
                    Lihat Semua
                  </Link>
                </div>
              </div>
              {/* End d-flex */}

              <RecentWithdrawl />
            </div>
            {/* End py-30 */}
          </div>
          <div className="col-12 col-lg-6">
            <div className="py-30 px-30 rounded-4 bg-white shadow-3 h-100">
              <div className="d-flex justify-between items-center">
                <h2 className="text-16 lh-1 fw-500">Pengembalian Dana</h2>
                <div>
                  <Link to="/refund" className="text-12 text-blue-1 fw-500 underline">
                    Lihat Semua
                  </Link>
                </div>
              </div>
              {/* End d-flex */}

              <RecentRefund />
            </div>
            {/* End py-30 */}
          </div>
          <div className="col-12 col-lg-6">
            <div className="py-30 px-30 rounded-4 bg-white shadow-3 h-100">
              <div className="d-flex justify-between items-center">
                <h2 className="text-16 lh-1 fw-500">Tenant Baru</h2>
                <div>
                  <Link to="/tenants" className="text-12 text-blue-1 fw-500 underline">
                    Lihat Semua
                  </Link>
                </div>
              </div>
              {/* End d-flex */}

              <RecentTenantApproval />
            </div>
            {/* End py-30 */}
          </div>
          <div className="col-12 col-lg-6">
            <div className="py-30 px-30 rounded-4 bg-white shadow-3 h-100">
              <div className="d-flex justify-between items-center">
                <h2 className="text-16 lh-1 fw-500">Tautan</h2>
              </div>
              {/* End d-flex */}
              <ul className="mt-10 useful-links">
                <li>
                  <a
                    className="text-14 text-blue-1"
                    href="https://docs.midtrans.com/docs/testing-payment-on-sandbox"
                    target="_blank"
                    rel="noreferrer">
                    Midtrans
                  </a>
                </li>
                <li>
                  <a
                    className="text-14 text-blue-1"
                    href="https://docs.midtrans.com/docs/testing-payment-on-sandbox"
                    target="_blank"
                    rel="noreferrer">
                    Firebase
                  </a>
                </li>
                <li>
                  <a
                    className="text-14 text-blue-1"
                    href="https://docs.midtrans.com/docs/testing-payment-on-sandbox"
                    target="_blank"
                    rel="noreferrer">
                    AWS - S3
                  </a>
                </li>
              </ul>
            </div>
            {/* End py-30 */}
          </div>
          {/* End .col */}
        </div>
      </div>
      {/* End .col-12 */}
    </div>
  );
}

export default Dashboard;
